import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class BillProjectHoursRequestFilter<T extends EMode = EMode.entity> {
  /** Alias: projectCode */
  projectCode?: number;
  /** Alias: fromDate */
  fromDate?: string;
  /** Alias: toDate */
  toDate?: string;
  /** Alias: onlyNotBilled */
  onlyNotBilled?: boolean;
  /** Alias: projectTimeCodes */
  projectTimeCodes?: number[];
  /** Alias: onlyCompletedTickets */
  onlyCompletedTickets?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<BillProjectHoursRequestFilter> = {
  projectCode: {
    alias: 'projectCode',
  },
  fromDate: {
    alias: 'fromDate',
  },
  toDate: {
    alias: 'toDate',
  },
  onlyNotBilled: {
    alias: 'onlyNotBilled',
  },
  projectTimeCodes: {
    alias: 'projectTimeCodes',
  },
  onlyCompletedTickets: {
    alias: 'onlyCompletedTickets',
  },
  __typename: {
    alias: '__typename',
  },
};

export const billProjectHoursRequestFilterEntityDefinition: EntitiyDefinition<BillProjectHoursRequestFilter> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BillProjectHoursRequestFilter',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
